import { Delete, UploadFile } from "@mui/icons-material";
import { Box, Grid, IconButton, Paper, Stack, Typography, useTheme } from "@mui/material";
import { useCallback, useState } from "react";

export const FileDropperV2 = ({ onFilesChange }) => {

  const [files, setFiles] = useState([]);
  const theme = useTheme();

  const handleFiles = useCallback((fileList) => {
    const newFiles = Array.from(fileList).filter((file) =>
      file.type.includes('image') || file.type === 'application/pdf'
    );
    setFiles((prev) => [...prev, ...newFiles]);
    onFilesChange && onFilesChange([...files, ...newFiles]);
  }, [files, onFilesChange]);

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleInputChange = (e) => {
    handleFiles(e.target.files);
  };

  const handleRemove = (index) => {
    const updated = [...files];
    updated.splice(index, 1);
    setFiles(updated);
    onFilesChange && onFilesChange(updated);
  };

  return (
    <Box>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          border: `2px dashed ${theme.palette.primary.main}`,
          textAlign: 'center',
          cursor: 'pointer',
          bgcolor: theme.palette.background.default,
          '&:hover': {
            bgcolor: theme.palette.action.hover,
          },
        }}
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onClick={() => document.getElementById('file-input').click()}
      >
        <UploadFile fontSize="large" color="primary" />
        <Typography variant="h6" mt={2}>
          Arrastra imágenes o PDFs aquí, o haz clic para seleccionar
        </Typography>
        <input
          id="file-input"
          type="file"
          multiple
          accept="image/*,.pdf"
          style={{ display: 'none' }}
          onChange={handleInputChange}
        />
      </Paper>

      {files.length > 0 && (
        <Grid container spacing={2} mt={3}>
          {files.map((file, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                {file.type.startsWith('image') ? (
                  <Box
                    component="img"
                    src={URL.createObjectURL(file)}
                    alt={file.name}
                    sx={{
                      width: 60,
                      height: 60,
                      objectFit: 'cover',
                      mr: 2,
                      borderRadius: 1,
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      mr: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'grey.200',
                      borderRadius: 1,
                    }}
                  >
                    <UploadFile />
                  </Box>
                )}
                <Typography noWrap sx={{ flexGrow: 1 }}>{file.name}</Typography>
                <IconButton onClick={() => handleRemove(index)} color="error">
                  <Delete />
                </IconButton>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}